import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconGoogleStyle0 = gravityIconIndividualCss;

const GravityIconGoogle = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '8a73ae52afec7d181c03e5191ee2851ef073cc6d', color: this.color, size: this.size }, h("svg", { key: 'bec2005155a3430cd248887d3917e17a5530820c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '4916bfc7ddd29abb18229bc37af5baf0e2c0f25c', d: "M2 11c0-4.963 4.037-9 9-9 2.004 0 3.901.645 5.486 1.865l-2.091 2.717A5.517 5.517 0 0 0 11 5.429 5.578 5.578 0 0 0 5.429 11 5.577 5.577 0 0 0 11 16.571a5.581 5.581 0 0 0 5.302-3.857H11V9.286h9V11c0 4.963-4.037 9-9 9s-9-4.037-9-9Z", fill: "currentColor" }))));
    }
};
GravityIconGoogle.style = GravityIconGoogleStyle0;

export { GravityIconGoogle as gravity_icon_google };

//# sourceMappingURL=gravity-icon-google.entry.js.map